<template>
    <b-container fluid class="mt-5">
        <div class="row card shadow" md="12">
            <div class="col-lg-12">
                <h3 class="text-center"> Utilisateurs</h3>
                <hr>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de Patients">
                            <b-card-text>
                                {{this.metrique.nbre_patients}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de Souscripteurs">
                            <b-card-text>
                                {{this.metrique.nbre_souscripteurs}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de Praticiens">
                            <b-card-text>
                                {{this.metrique.nbre_praticiens}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de Médecin contrôle">
                            <b-card-text>
                                {{this.metrique.nbre_medecin_controles}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre d'Amas">
                            <b-card-text>
                                {{this.metrique.nbre_amas}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de Gestionnaire">
                            <b-card-text>
                                {{this.metrique.nbre_gestionnaires}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre d'Administrateur">
                            <b-card-text>
                                {{this.metrique.nbre_admins}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre d'utilisateurs interne">
                            <b-card-text>
                                {{this.metrique.nbre_users_internes}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre d'utilisateurs externe">
                            <b-card-text>
                                {{this.metrique.nbre_users_externes}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="row">
                        <div class="mt-3 col-lg-12">
                        <!-- <h3>Nombre </h3> -->
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-1 variant="success">Nombre de souscripteur par pays</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> PAYS </th>
                                                <th scope="col"> NOMBRES </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.metrique.nbre_souscripteurs_par_pays" :key="index">
                                            <tr>
                                                <td>{{ elements.pays }}</td>
                                                <td>{{ elements.nombres}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                        </div>
                        <div class="mt-3 col-lg-12">
                            <!-- <h3>Nombre </h3> -->
                            <div class="accordion col-12" role="tablist">
                                <b-card no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-button block v-b-toggle.accordion-2 variant="success">Nombre de souscripteur par ville</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                    <table class="table">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th scope="col"> Ville </th>
                                                    <th scope="col"> NOMBRES </th>
                                                </tr>
                                            </thead>
                                            <tbody v-for="(elements, index) in this.metrique.nbre_souscripteurs_par_ville" :key="index">
                                                <tr>
                                                    <td>{{ elements.ville }}</td>
                                                    <td>{{ elements.nombres}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-card-body>
                                </b-collapse>
                                </b-card>
                            </div>
                        </div>
                        <div class="mt-3 col-lg-12">
                            <!-- <h3>Nombre </h3> -->
                            <div class="accordion col-12" role="tablist">
                                <b-card no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-button block v-b-toggle.accordion-3 variant="success">Nombre de patient par pays</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                    <table class="table">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th scope="col"> PAYS </th>
                                                    <th scope="col"> NOMBRES </th>
                                                </tr>
                                            </thead>
                                            <tbody v-for="(elements, index) in this.metrique.nbre_patient_par_pays" :key="index">
                                                <tr>
                                                    <td>{{ elements.pays }}</td>
                                                    <td>{{ elements.nombres}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-card-body>
                                </b-collapse>
                                </b-card>
                            </div>
                        </div>
                        <div class="mt-3 col-lg-12">
                            <div class="accordion col-12" role="tablist">
                                <b-card no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-button block v-b-toggle.accordion-4 variant="success">Nombre de patient par ville</b-button>
                                </b-card-header>
                                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                                    <b-card-body>
                                    <table class="table">
                                            <thead class="thead-light">
                                                <tr>
                                                    <th scope="col"> VILLE </th>
                                                    <th scope="col"> NOMBRES </th>
                                                </tr>
                                            </thead>
                                            <tbody v-for="(elements, index) in this.metrique.nbre_patient_par_ville" :key="index">
                                                <tr>
                                                    <td>{{ elements.ville }}</td>
                                                    <td>{{ elements.nombres}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-card-body>
                                </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <h3 class="text-center mt-3"> Produits</h3>
                <hr>
                <h4 class="text-center">CIM</h4>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre d’affiliation de janvier a juin">
                            <b-card-text>
                                {{this.metrique.nbre_affiliations_janvier_juin}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de cim de janvier a juin">
                            <b-card-text>
                                {{this.metrique.nbre_cim_janvier_juin}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de cim de cim total">
                            <b-card-text>
                                {{this.metrique.nbre_affiliations_janvier_juin + this.metrique.nbre_cim_janvier_juin}}
                            </b-card-text>
                        </b-card>
                    </div>
                </div>
                <hr>
                <h4 class="text-center"> Nouvelles offres</h4>
                <div class="row">
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre total d'offres">
                        <b-card-text>
                            {{this.metrique.nbre_offres}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3" v-for="(elements, index) in this.metrique.nbre_affiliation_par_offres" :key="index">
                    <b-card :title="elements.description_fr" sub-title="Nombres achetés">
                        <b-card-text>
                            {{ elements.affiliations_count }}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="row">
                    <div class="mt-3 col-lg-12">
                        <!-- <h3>Nombre </h3> -->
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-5 variant="success">Nombre d'offre par pays</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> PAYS </th>
                                                <th scope="col"> NOMBRES </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.metrique.nbre_offre_par_pays" :key="index">
                                            <tr>
                                                <td>{{ elements.pays }}</td>
                                                <td>{{ elements.nombres}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                    <div class="mt-3 col-lg-12">
                        <!-- <h3>Nombre </h3> -->
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-6 variant="success">Nombre d'offre par ville</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> VILLE </th>
                                                <th scope="col"> NOMBRES </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.metrique.nbre_offre_par_villes" :key="index">
                                            <tr>
                                                <td>{{ elements.ville }}</td>
                                                <td>{{ elements.nombres}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </div>
                </div>
                <h3 class="text-center mt-3"> Parcours de soins </h3>
                <hr>
                <div class="row">
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre total de ligne de temps">
                        <b-card-text>
                            {{this.metrique.nbre_ligne_temps}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre d'activités ama">
                        <b-card-text>
                            {{this.metrique.nbre_activite_amas}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre d'activités du médecin contrôle">
                        <b-card-text>
                            {{this.metrique.nbre_activite_controle}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de validations">
                        <b-card-text>
                            {{this.metrique.nbre_validations}}
                        </b-card-text>
                    </b-card>
                </div>
                </div>

                <h3 class="text-center mt-3"> Dossier médical </h3>
                <hr>
                <div class="row">
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de consultation medecine générale">
                        <b-card-text>
                            {{this.metrique.nbre_consultation_medecine_generale}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre d'allergies">
                        <b-card-text>
                            {{this.metrique.nbre_allergies}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de traitement actuels">
                        <b-card-text>
                            {{this.metrique.traitement_actuels}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de prescription">
                        <b-card-text>
                            {{this.metrique.nbre_prescriptions}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de résultat laboratoire">
                        <b-card-text>
                            {{this.metrique.nbre_resultat_laboratoire}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de résultat et imageries">
                        <b-card-text>
                            {{this.metrique.nbre_resultat_imageries}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre d'hospitalisation">
                        <b-card-text>
                            {{this.metrique.nbre_hospitalisations}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de fichiers medico externes">
                        <b-card-text>
                            {{this.metrique.fichier_medico_externes}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de dossiers médicaux">
                        <b-card-text>
                            {{this.metrique.nbre_dossier_medicaux}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de comptes rendu opératoire">
                        <b-card-text>
                            {{this.metrique.nbre_compte_rendu_operatoires}}
                        </b-card-text>
                    </b-card>
                </div>

                </div>
                <h3 class="text-center mt-3"> Avis Médicaux </h3>
                <hr>
                <div class="row">
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre d'Avis Médicaux">
                        <b-card-text>
                            {{this.metrique.nbre_avis}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre total d’avis médical donné">
                        <b-card-text>
                            {{this.metrique.nbre_medecin_avis}}
                        </b-card-text>
                    </b-card>
                </div>
                </div>
                <div class="row">
                    <div class="mt-3 col-lg-12">
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-12 variant="success">Nombre d’avis médicaux par médecin</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> Nom établissement </th>
                                                <th scope="col"> Nombre de rendez-vous </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.metrique.nbre_avis_par_medecins" :key="index">
                                            <tr>
                                                <td>{{ elements.civilite}} {{getFirstLetters( elements.nom + " " + elements.prenom )}} </td>
                                                <td>{{ elements.medecin_avis_count}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </div>

                
                <h3 class="text-center mt-3"> Rendez-vous </h3>
                <hr>
                <div class="row">
                <div class="col-lg-3 col-md-6 col-12 mt-3">
                    <b-card title="Nombre de rendez-vous total">
                        <b-card-text>
                            {{this.metrique.nbre_rendez_vous}}
                        </b-card-text>
                    </b-card>
                </div>
                <div class="row">
                    <div class="mt-3 col-lg-12">
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-7 variant="success">Nombre de rendez-vous par patient</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> Numéro dossier </th>
                                                <th scope="col"> Nombre de rendez-vous </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.metrique.nbre_rendez_vous_par_patients" :key="index">
                                            <tr>
                                                <td v-if="elements.dossier">{{ elements.dossier.numero_dossier }} </td>
                                                <td>{{ elements.rendez_vous_count}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                    <div class="mt-3 col-lg-12">
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-8 variant="success">Nombre de rendez-vous par praticien</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> Numéro d'ordre </th>
                                                <th scope="col"> Nombre de rendez-vous </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.metrique.nbre_rendez_vous_par_praticiens" :key="index">
                                            <tr>
                                                <td>{{ elements.numero_ordre }}</td>
                                                <td>{{ elements.rendez_vous_count}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                    <div class="mt-3 col-lg-12">
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-9 variant="success">Nombre de rendez-vous par medécin référent</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> Numéro d'ordre </th>
                                                <th scope="col"> Nombre de rendez-vous </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.metrique.nbre_rendez_vous_par_medecin_referents" :key="index">
                                            <tr>
                                                <td>{{ elements.numero_ordre}}</td>
                                                <td>{{ elements.rendez_vous_count}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                    <div class="mt-3 col-lg-12">
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-10 variant="success">Nombre de rendez-vous par etablissement</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> Nom établissement </th>
                                                <th scope="col"> Nombre de rendez-vous </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.metrique.nbre_rendez_vous_par_etablissement" :key="index">
                                            <tr>
                                                <td>{{ elements.name}}</td>
                                                <td>{{ elements.rendez_vous_count}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </div>
                    
                </div>
                <h3  class="text-center mt-3">Médecins référents</h3>
                <hr>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de médecin référent">
                            <b-card-text>
                                {{this.metrique.nbre_medecin_referents}}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de patient ayant un médecin référent">
                            <b-card-text>
                                {{this.metrique.nbre_patient_avec_medecin_referents}}
                            </b-card-text>
                        </b-card>
                    </div>
                </div>
                <div class="row">
                    <div class="mt-3 col-lg-12">
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-11 variant="success">Liste des Médecins Référents ayant le plus de patient</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-11" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> Nom médécin</th>
                                                <th scope="col"> Nombre de patient </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.metrique.medecin_referent_ayant_plus_patients" :key="index">
                                            <tr>
                                                <td>{{ elements.civilite}} {{getFirstLetters( elements.user.nom + " " + elements.user.prenom )}} </td>
                                                <td>{{ elements.patients_count}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </div>
                

                <h3  class="text-center mt-3">Patients</h3>
                <hr>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Nombre de patients décédés">
                            <b-card-text>
                                {{this.metrique.nbre_patient_decedes}}
                            </b-card-text>
                        </b-card>
                    </div>
                </div>

                <div class="row">
                    <div class="mt-3 col-lg-12">
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-13 variant="success">Liste de connexion des partenaire/praticien</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-13" accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> Partenaire/Praticien</th>
                                                <th scope="col"> Nombre de connexion </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.connexion" :key="index">
                                            <tr>
                                                <td v-if="elements.user">{{ elements.civilite}} {{ elements.user.nom + " " + elements.user.prenom }} </td>
                                                <td>{{ elements.time_count}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="mt-3 col-lg-12">
                        <div class="accordion col-12" role="tablist">
                            <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <b-button block v-b-toggle.accordion-14 variant="success">Liste des 10 derniers cim urgence et urgence plus</b-button>
                            </b-card-header>
                            <b-collapse id="accordion-14" visible accordion="my-accordion" role="tabpanel">
                                <b-card-body>
                                <table class="table">
                                        <thead class="thead-light">
                                            <tr>
                                                <th scope="col"> Numéro du dossier</th>
                                                <th scope="col"> Nom cim </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(elements, index) in this.lastestaffiliation" :key="index">
                                            <tr>
                                                <td>{{ elements.patient.dossier.numero_dossier}} </td>
                                                <td>{{ elements.package.description_fr}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </b-card-body>
                            </b-collapse>
                            </b-card>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Durée moyenne de connexion des souscripteurs">
                            <b-card-text>
                                {{ this.dureeMoyenne.Souscripteur.DureeMoyenne }}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Durée moyenne de connexion des praticiens">
                            <b-card-text>
                                {{ this.dureeMoyenne.Praticien.DureeMoyenne }}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Durée moyenne de connexion des patients">
                            <b-card-text>
                                {{ this.dureeMoyenne.Patient.DureeMoyenne }}
                            </b-card-text>
                        </b-card>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Ecart type des souscripteurs">
                            <b-card-text>
                                {{ this.dureeMoyenne.Souscripteur.EcartType }}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Ecart type des praticiens">
                            <b-card-text>
                                {{ this.dureeMoyenne.Praticien.EcartType }}
                            </b-card-text>
                        </b-card>
                    </div>
                    <div class="col-lg-3 col-md-6 col-12 mt-3">
                        <b-card title="Ecart type des patients">
                            <b-card-text>
                                {{ this.dureeMoyenne.Patient.EcartType }}
                            </b-card-text>
                        </b-card>
                    </div>
                </div>
                <div class="row">
                    
                </div>
                <div class="row">
                        <div class="mt-3 col-lg-12">
                            <div class="accordion col-12" role="tablist">
                                <b-card no-body class="mb-1">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-button block v-b-toggle.accordion-15 variant="success">Liste des durées de session moyenne, par année, par rôle</b-button>
                                </b-card-header>
                                    <b-collapse id="accordion-15" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                            <table class="table">
                                                <thead class="thead-light">
                                                    <tr>
                                                        <th scope="col"> Roles </th>
                                                        <th scope="col"> Année </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Admin</td>
                                                        <td>
                                                            <ul v-for="(admin, index) in this.dureeMoyenneAllRoles.Admin" :key="index">
                                                                <li>{{ admin.year }} - {{ admin.total_duration }}</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Assistante</td>
                                                        <td>
                                                            <ul v-for="(assistante, index) in this.dureeMoyenneAllRoles.Assistante" :key="index">
                                                                <li>{{ assistante.year }} - {{ assistante.total_duration }}</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Etablissement</td>
                                                        <td>
                                                            <ul v-for="(etablissement, index) in this.dureeMoyenneAllRoles.Etablissement" :key="index"> 
                                                                <li>{{ etablissement.year }} - {{ etablissement.total_duration }}</li> 
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Gestionnaire</td>
                                                        <td>
                                                            <ul v-for="(gestionnaire, index) in this.dureeMoyenneAllRoles.Gestionnaire" :key="index"> 
                                                                <li>{{ gestionnaire.year }} - {{ gestionnaire.total_duration }}</li> 
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Patient</td>
                                                        <td>
                                                            <ul  v-for="(patient, index) in this.dureeMoyenneAllRoles.Patient" :key="index">
                                                                <li>{{ patient.year }} - {{ patient.total_duration }}</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Praticien</td>
                                                        <td>
                                                            <ul v-for="(praticien, index) in this.dureeMoyenneAllRoles.Praticien" :key="index">
                                                                <li>{{ praticien.year }} - {{ praticien.total_duration }}</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Souscripteur</td>
                                                        <td>
                                                            <ul v-for="(souscripteur, index) in this.dureeMoyenneAllRoles.Souscripteur" :key="index">
                                                                <li>{{ souscripteur.year }} - {{ souscripteur.total_duration }}</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Medecin controle</td>
                                                        <td>
                                                            <ul v-for="(medecin, index) in this.dureeMoyenneAllRoles['Medecin controle']" :key="index">
                                                                <li>{{ medecin.year }} - {{ medecin.total_duration }}</li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </b-container>
    <!-- IMPORTANT: L'attribut "visible" qui permet l'ouverture des accordion par defauts -->
</template>
<script>
import axios from 'axios';
import AppConfig from "../../constants/AppConfig";

export default {
  name: "dashboard-metrique",
  data() {
    return {
        metrique : [],
        connexion : [],
        lastestaffiliation: [],
        dureeMoyenne: [],
        dureeMoyenneAllRoles: []
    };
  },
  methods: {
    getFirstLetters(str) {
        const firstLetters = str
            .split(' ')
            .map(word => word[0])
            .join('');

        return firstLetters;
    },
    getMetrique(){
        // let metrique;
        axios.get(`${AppConfig.apiUrl}/v1/dashboard`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
        .then(res => {
            // console.log(res.data);
            this.metrique = res.data;
            // console.log(metrique);
        })
        .catch((error) => {
                //console.log("error ", error)
        });
    },
    getPraticienConnexion(){
        // let metrique;
        axios.get(`${AppConfig.apiUrl}/timeactivities`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
        .then(res => {
            // console.log(res.data.praticien);
            this.connexion = res.data.praticien;
            // console.log(metrique);
        })
        .catch((error) => {
                //console.log("error ", error)
        });
    },

    getLastestAffiliation(){
        // let metrique;
        axios.get(`${AppConfig.apiUrl}/lastestaffiliation`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
        .then(res => {
            // console.log(res.data);
            this.lastestaffiliation = res.data;
            // console.log(metrique);
        })
        .catch((error) => {
                //console.log("error ", error)
        });
    },

    getDureeMoyenne() {
        // let metrique;
        axios.get(`${AppConfig.apiUrl}/duree-moyenne`, { headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` } })
        .then(res => {
            // console.log(res.data);
            this.dureeMoyenne = res.data;
            // console.log(metrique);
        })
        .catch((error) => {
            //console.log("error ", error)
        });
      },
    
    getDureeMoyenneAllRoles() {
    // let metrique;
    axios.get(`${AppConfig.apiUrl}/duree-moyenne-all-roles`, { headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` } })
        .then(res => {
            // console.log(res.data);
            this.dureeMoyenneAllRoles = res.data;
            // console.log(metrique);
        })
        .catch((error) => {
            //console.log("error ", error)
        });
    }

  },
    mounted() {
        this.getMetrique();
        this.getPraticienConnexion();
        this.getLastestAffiliation();
        this.getDureeMoyenne();
        this.getDureeMoyenneAllRoles();
    },
};
</script>